import React from 'react';
import { Select } from 'src/components/index';

const LoadingSelect = (props = {}) => (
  <Select id='loading-select' loading {...props} />
);

export default LoadingSelect;
